/* tslint:disable */
import {Injectable} from '@angular/core';
import {BaseRestService} from './base-rest.service';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from './app-settings.service';
import {Observable} from 'rxjs';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {SharedModule} from '../shared.module';
import {BillingProduct, Product} from '../models/product';
import {Concept} from '../models/concept';

@Injectable({providedIn: SharedModule})
export class ConceptService extends BaseRestService {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }

  protected get className(): string {
    return 'ConceptService';
  }

  protected get isAnonymous(): boolean {
    return false;
  }

  getList(clientUuid: string): Observable<SendBackResult<ArrayResponse<Concept>>> {
    return this.get<ArrayResponse<Concept>>(`/clients/${clientUuid}/Concepts`);
  }
}
